import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  getAccountVehiclePurchases,
  getAccountVehiclePurchase,
  createAccountVehiclePurchase,
  updateAccountVehiclePurchase,
  deleteAccountVehiclePurchase,
} from 'api/accountVehiclePurchaseApi'

export const useAccountVehiclePurchases = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: ['account-vehicle-purchases', params],
    queryFn: () => getAccountVehiclePurchases(params),
    enabled,
  })
}

export const useAccountVehiclePurchase = (id, enabled = true) => {
  return useQuery({
    queryKey: ['account-vehicle-purchases', id],
    queryFn: () => getAccountVehiclePurchase(id),
    enabled: enabled && !!id,
  })
}

export const useCreateAccountVehiclePurchase = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createAccountVehiclePurchase,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-vehicle-purchases'] })
    },
  })
}

export const useEditAccountVehiclePurchase = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...data }) => updateAccountVehiclePurchase(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-vehicle-purchases'] })
    },
  })
}

export const useDeleteAccountVehiclePurchase = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteAccountVehiclePurchase,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-vehicle-purchases'] })
    },
  })
}
